import { render, staticRenderFns } from "./Tee.vue?vue&type=template&id=5837fae4&scoped=true"
import script from "./Tee.vue?vue&type=script&lang=js"
export * from "./Tee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5837fae4",
  null
  
)

export default component.exports